/* eslint-disable import/no-anonymous-default-export */
export default {
    fam:{
        semibold:"Semi-Bold",
        bold:"bold"
    },
    color:{
        red:"#B7253C",
        blue:"#1473E6",
        lightblue:"#D0E3FA",
        greybg:"rgba(184, 184, 184, 0.3)",
    }
}